// These are form defaults, not confirmed property locations. Do not geocode here.
const FORM_DEFAULTS = [[34.802075, 9.055876], [33.8869, 9.5375]];

function coordinate(value) {
  if (!['number', 'string'].includes(typeof value) || String(value).trim() === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function listingCoordinates(listing) {
  const latitude = coordinate(listing.latitude ?? listing.Latitude);
  const longitude = coordinate(listing.longitude ?? listing.Longitude);
  if (latitude === null || longitude === null || Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;
  if (latitude === 0 && longitude === 0) return null;
  if (FORM_DEFAULTS.some(([lat, lng]) => Math.abs(lat - latitude) < 0.0000001 && Math.abs(lng - longitude) < 0.0000001)) return null;
  return [latitude, longitude];
}

export function listingMapPoints(listings) {
  const points = new Map();
  listings.forEach(listing => {
    const id = listing.id ?? listing.ID ?? listing.bienID ?? listing.BienID ?? listing.vacationID;
    const position = listingCoordinates(listing);
    if (id != null && position) points.set(String(id), { id: String(id), position, listing });
  });
  return [...points.values()];
}

export function listingMapPrice(listing) {
  const normal = Number(listing.prix ?? listing.Prix);
  const reduced = Number(listing.prixReduit ?? listing.PrixReduit);
  const offer = listing.offre ?? listing.Offre;
  if (!Number.isFinite(normal) || normal <= 0) return null;
  return (offer === true || offer === 'true') && reduced > 0 && reduced < normal ? reduced : normal;
}

export function listingMapPriceLabel(listing, kind, t, language) {
  const price = listingMapPrice(listing);
  if (price === null) return t('mapView.noPrice');
  const amount = new Intl.NumberFormat(language, { maximumFractionDigits: 2 }).format(price);
  const isRent = ['rent', 'location', 'louer'].includes(String(listing.type ?? listing.Type ?? '').toLowerCase());
  return t(kind === 'vacation' ? 'mapView.nightlyPrice' : isRent ? 'mapView.monthlyPrice' : 'mapView.price', { price: amount });
}

export function listingGeoJSON(points, kind, t, language) {
  return { type: 'FeatureCollection', features: points.map(point => ({
    type: 'Feature', id: point.id,
    geometry: { type: 'Point', coordinates: [point.position[1], point.position[0]] },
    properties: { id: point.id, price: listingMapPrice(point.listing) ?? 0, label: compactMapPrice(listingMapPrice(point.listing), t, language) },
  })) };
}

export function compactMapPrice(price, t, language) {
  if (!price) return t('mapView.noPrice');
  const divisor = price >= 999950 ? 1000000 : price >= 1000 ? 1000 : 1;
  const amount = new Intl.NumberFormat(language, { maximumFractionDigits: divisor === 1 ? 0 : 1 }).format(price / divisor);
  return divisor === 1 ? `${amount} DT` : `${amount}${divisor === 1000 ? 'k' : 'M'}`;
}
